import { EuCoreServicesModule } from '@eucoms/common-components';

const baseUrl = 'https://s-secure.bge.com';
const anonBaseUrl = 'https://draft.bge.com';
const middlewareUrl = 'https://eudapi-dev.bge.com/content-api';
const euAPIUrl = 'https://eudapi-dev.bge.com';
const euApiPrefix = '/content-api';

export const mockConfigProvider = () =>
  EuCoreServicesModule.mockAppConfigService({
    common: {
      anonBaseUrl,
      baseUrl,
      contentApiBaseUrl: middlewareUrl,
      contentApiRoutePrefix: euApiPrefix,
      euApiUrl: euAPIUrl,
      opCo: 'BGE',
    },
  });

export const mockConfigValues = {
  ACE: {
    anonBaseUrl: 'https://draft.atlanticcityelectric.com',
    baseUrl: 'https://s-secure.atlanticcityelectric.com',
    contentApiBaseUrl: 'https://eudapi-dev.atlanticcityelectric.com/content-api',
    contentApiRoutePrefix: euApiPrefix,
    euApiUrl: 'https://eudapi-dev.atlanticcityelectric.com',
    opCo: 'ACE'
  },
  BGE: {
    anonBaseUrl: 'https://draft.bge.com',
    baseUrl: 'https://s-secure.bge.com',
    contentApiBaseUrl: 'https://eudapi-dev.bge.com/content-api',
    contentApiRoutePrefix: euApiPrefix,
    euApiUrl: 'https://eudapi-dev.bge.com',
    opCo: 'BGE'
  },
  ComEd: {
    anonBaseUrl: 'https://draft.comed.com',
    baseUrl: 'https://s-secure.comed.com',
    contentApiBaseUrl: 'https://eudapi-dev.comed.com/content-api',
    contentApiRoutePrefix: euApiPrefix,
    euApiUrl: 'https://eudapi-dev.comed.com',
    opCo: 'ComEd'
  },
  DPL: {
    anonBaseUrl: 'https://draft.delmarva.com',
    baseUrl: 'https://s-secure.delmarva.com',
    contentApiBaseUrl: 'https://eudapi-dev.delmarva.com/content-api',
    contentApiRoutePrefix: euApiPrefix,
    euApiUrl: 'https://eudapi-dev.delmarva.com',
    opCo: 'DPL'
  },
  PECO: {
    anonBaseUrl: 'https://draft.peco.com',
    baseUrl: 'https://s-secure.peco.com',
    contentApiBaseUrl: 'https://eudapi-dev.peco.com/content-api',
    contentApiRoutePrefix: euApiPrefix,
    euApiUrl: 'https://eudapi-dev.peco.com',
    opCo: 'PECO'
  },
  PEPCO: {
    anonBaseUrl: 'https://draft.pepco.com',
    baseUrl: 'https://s-secure.pepco.com',
    contentApiBaseUrl: 'https://eudapi-dev.pepco.com/content-api',
    contentApiRoutePrefix: euApiPrefix,
    euApiUrl: 'https://eudapi-dev.pepco.com',
    opCo: 'PEPCO'
  },
};
